<template>
	<bsf-smenu>
		<bsf-smenuli v-for="(sidemenu,index) in router" :icon="sidemenu.iconname" :label="sidemenu.label" :route="sidemenu.path">
			<bsf-badges slot="label" v-if="!!sidemenu.hasmsg" :imp="sidemenu.imp" :val="sidemenu.msg"></bsf-badges>
			<bsf-smenu slot="menu" v-if="!!sidemenu.crouter">
				<bsf-smenuli v-for="(sidemenuc,index) in sidemenu.crouter" :label="sidemenuc.label" :route="sidemenuc.path">
					<bsf-badges slot="label" :imp="sidemenuc.imp" :val="sidemenuc.msg"></bsf-badges>
				</bsf-smenuli>
			</bsf-smenu>
		</bsf-smenuli>
	</bsf-smenu>
</template>
<script>
	import bsfSmenu from './comp/smenu'
	import bsfSmenuli from './comp/slot/smenuli'
	import bsfLabel from './comp/label'
	import bsfBadges from './comp/badges'
	import { mapState } from 'vuex'
	export default {
		name: 'sidebar',
		components: {
			bsfSmenu,
			bsfSmenuli,
			bsfLabel,
			bsfBadges
		},
		data() {
			return {
				router: [{
					label: "首页面板",
					path: {
						path: '/index'
					},
					iconname: 'home',
					hasmsg: true,
					msg: 3,
					imp: true,
					crouter: [{
						label: "样式一",
						path: {
							path: '/index/temp1'
						}
					}, {
						label: "样式二",
						path: {
							path: '/index/temp2'
						}
					}, {
						label: "样式三",
						path: {
							path: '/index/temp3'
						}
					}]
				}, {
					label: "布局系统/Layout",
					path: {
						path: '/grid'
					},
					iconname: "zheqi",
					hasmsg: true,
					msg: 3,
				}, {
					label: "表单/forms",
					path: {
						path: '/forms'
					},
					iconname: "gongdan",
					hasmsg: true,
					msg: 10,
					imp: true,
				}, {
					label: "图表",
					path: {
						path: '/chart'
					},
					iconname: "baobiao",
				}, {
					label: "swiper",
					path: {
						path: '/swiper'
					},
					iconname: "baobiao",
				}, {
					label: "我亲爱的组件们",
					path: {
						path: '/comps'
					},
					iconname: 'home',
					hasmsg: true,
					msg: 3,
					imp: true,
					crouter: [{
						label: "thumbnail",
						path: {
							path: '/comps/thumbnail'
						}
					}]
				}]
			}
		},
		computed: {
			...mapState([
				'bcArray'
			])
		},
	}
</script>


// WEBPACK FOOTER //
// sidebar.vue?1b917828